<template>
  <div class="md-card-tabs">
    <div class="">
      <md-list class="nav-tabs">
        <md-list-item
          v-for="(item, index) in tabName"
          @click="switchPanel(tabName[index])"
          :key="item"
          :class="[
          { active: isActivePanel(tabName[index]) },
          { [getColorButton(colorButton)]: isActivePanel(tabName[index]) }
          ]"
          >
          {{ tabName[index] }}
          <md-icon v-if="navPillsIcons">{{ tabIcon[index] }}</md-icon>
        </md-list-item>
      </md-list>
      <md-list class="nav-tabs-mobile">
        <div class="active-item" @click="openTabList"><span>Project Menu/Functions</span> <span><i class="material-icons">expand_more</i></span> </div>
        <ul  v-if="openList" class="popover-list">
          <li
            v-for="(item, index) in mobileNames"
            @click="selectTab(index, tabName[index])"
            :key="item"
          >
            {{mobileNames[index]}}
          </li>
        </ul>
      </md-list>

    <transition name="fade" mode="out-in">
      <div class="tab-content">
        <template v-for="(item, index) in tabName">
          <template v-if="isActivePanel(tabName[index])">
            <div :class="getTabContent(index + 1)" :key="item">
              <slot :name="getTabContent(index + 1)">
                This is the default text!
              </slot>
            </div>
          </template>
        </template>
      </div>
    </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    flexColumn: Boolean,
    navPillsIcons: Boolean,
    plain: Boolean,
    tabName: Array,
    activeTab: String,
    tabIcon: Array,
    mobileNames: Array,
    linkTab: Object,
    colorButton: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      activePanel: this.activeTab,
      openList: false,
      selected: 0,
    };
  },
  methods: {
    switchPanel(panel) {
      if (this.linkTab && this.linkTab[panel]) {
        this.$router.push(this.linkTab[panel]);
      } else {
        this.activePanel = panel;
      }
    },
    isActivePanel(panel) {
      return this.activePanel == panel;
    },
    getColorButton: function(colorButton) {
      return "md-plain";
    },
    getTabContent: function(index) {
      return "tab-pane-" + index + "";
    },
    openTabList: function() {
      console.log('open list');
      this.openList = !this.openList;
    },
    selectTab: function(index, name) {
      console.log(index);
      if (this.linkTab && this.linkTab[name]) {
        this.$router.push(this.linkTab[name]);
      } else {
        this.selected = index;
        this.activePanel = name;
        this.openList = false;
      }
    }
  }
};
</script>

<style lang="scss">
  .active-item {
    span {
      vertical-align: center;

    }
    i {
      font-size: 16px;
      vertical-align: center;
      font-weight: bold;
      // margin-top: 10px;
    }
  }

  .info-li {
    font-weight: normal;
    color: black;
  }
</style>
